import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatPlaylistSubmissionData, PlaylistEditor, usePlaylistForm, useSubmitPlaylistEditor } from 'screens/PlaylistEditorModal';
import { EditorPageStickySaveDiscardButton } from 'components/EditorPageStickyFooter';
import UnsavedChangesPrompt from 'components/UnsavedChangesPrompt';
export function EditPlaylistDetailsPage(_ref) {
  var initialPlaylistDetails = _ref.initialPlaylistDetails,
    _ref$inContentManager = _ref.inContentManagerContext,
    inContentManagerContext = _ref$inContentManager === void 0 ? false : _ref$inContentManager,
    onSubmit = _ref.onSubmit;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var playlistForm = usePlaylistForm({
    playlist: initialPlaylistDetails
  });
  var _useSubmitPlaylistEdi = useSubmitPlaylistEditor({
      playlistId: initialPlaylistDetails.id,
      badge: initialPlaylistDetails.badge,
      ownerTeamId: initialPlaylistDetails.ownerTeamId
    }),
    submitPlaylistEditor = _useSubmitPlaylistEdi.submitPlaylistEditor,
    isSubmissionLoading = _useSubmitPlaylistEdi.isSubmissionLoading;
  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    var cleanedPlaylistData = formatPlaylistSubmissionData({
      playlistForm: playlistForm,
      isEditMode: true
    });
    if (onSubmit) {
      onSubmit(cleanedPlaylistData);
    } else {
      submitPlaylistEditor(cleanedPlaylistData);
    }
  };
  return /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement(UnsavedChangesPrompt, {
    hasUnsavedChanges: playlistForm.wasChanged
  }), /*#__PURE__*/React.createElement(PlaylistEditor, {
    playlistForm: playlistForm,
    playlist: initialPlaylistDetails
  }), /*#__PURE__*/React.createElement(EditorPageStickySaveDiscardButton, {
    cardVariant: "raised",
    hasChanges: playlistForm.wasChanged,
    isDisabled: playlistForm.hasErrors,
    isSaving: isSubmissionLoading,
    onDiscard: function onDiscard() {
      return playlistForm.reset();
    },
    buttonText: t(inContentManagerContext ? 'actions_done' : 'actions_save_changes')
  }));
}